import type { IDisposable } from './IDisposable';

export class AutoResource<T> implements IDisposable {
  private _resource: T;

  private _disposer?: (resource: T) => void;

  public constructor(resource: T, disposer: (resource: T) => void) {
    this._resource = resource;
    this._disposer = disposer;
  }

  public get(): T {
    return this._resource;
  }

  public dispose(): void {
    if (!this._disposer) {
      throw new Error('Already disposed');
    }
    this._disposer(this._resource);
    this._disposer = undefined;
  }
}
